var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CpButton',{staticClass:"cancel-button",attrs:{"callback":_vm.callback,"color":"transparent"}},[_c('span',{staticClass:"close-x"}),_vm._v(" Abbrechen ")])}
var staticRenderFns = []

export { render, staticRenderFns }